<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 bg-l-gray" 
         tabindex="-1" 
         id="offcanvasAttView" 
         aria-labelledby="offcanvasAttViewLabel"
         @blur="focusOff()"
      >
      <!--
         data-bs-backdrop="false" 
         @blur="focusOff()"
      -->
      <div class="offcanvas-header row">
            <div class="col-1">
               &nbsp;
            </div>
            <div class="col-10 text-center clr-white">
               <h6 id="offcanvasAttViewLabel"><b>{{attachName}}</b></h6>
            </div>
            <div class="col-1 text-center">
               <button class="btn btn-link btn-exit"
                  type="button"
                  id="btn_close_offcanvas_attach"
                  data-bs-dismiss="offcanvas" 
                  aria-label="Close" 
                  ref="btn_close_offcanvas"
               >
               <b>X</b>
               </button>
            </div>
      </div>
      <div class="offcanvas-body">
         <!-- -->
         <div class="row">
         <button class="carousel-control-prev alto" type="button" data-bs-target="#carouselAttach" data-bs-slide="prev">
            <span class="carousel-control-prev-icon bg-secondary rounded-3" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
         </button>
         <div id="carouselAttach" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
            <div class="carousel-inner">
                  <div 
                  v-for="(attach, index) in attachs" 
                  :key="index" 
                  class="carousel-item  text-center"
                  :class="attachId==attach.id ? 'active' : ''"
                  >
                     <div v-if="isImage(attach.name)">
                        <!--
                        <img class="of-x"
                           :src="`/WorkSpace/Content/Attach/${attach.id}_${attach.name}`" 
                           alt=""
                        > -->
                        <img class="of-x"
                           :src="encodeURIComponent(attachFolder+`${attach.id}_${attach.name}`)" 
                           alt=""
                        >
                     </div>
                     <div v-else>
                        <div v-if="extension(attach.name).toUpperCase()=='PDF'">
                           <vuePdfEmbed :source="encodeURIComponent(pdfUrl)" />
                        </div>
                        <div v-else class="clr-white pt-5">
                           <b>No existe ninguna visualización previa disponible para este adjunto.</b>
                        </div>
                     </div>
                  </div>
            </div>
         </div>
         <button class="carousel-control-next alto" type="button" data-bs-target="#carouselAttach" data-bs-slide="next">
            <span class="carousel-control-next-icon bg-secondary rounded-3" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
         </button>
         </div>
         <!-- -->
      </div>
   </div>
   </div>
   <!--
                        <vuePdfEmbed :source="`/WorkSpace/Content/Attach/${attach.id}_${attach.name}`" />
   -->
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import vuePdfEmbed from 'vue-pdf-embed'
import WspService from "../workSpace.service";

export default {
   components: {
      vuePdfEmbed,
   },
   setup() {
      const store = useStore()
      const attachFolder = process.env.VUE_APP_BASE_CNTT_ATT_FOLDER

      const attachs = ref([])
      const attachId = ref(0)
      const attachName = ref("")
      const boardId = ref(0)
      const cellId = ref(0)
      const cnttId = ref(store.state.wspace.contentId)
      const content = ref({})
      const pdfUrl = ref(null)
      const putOff = ref(false)

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasAttView')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
            console.log(store.state.wspace.contentId)
            cnttId.value = store.state.wspace.contentId
            let button = event.relatedTarget
            cellId.value = button.getAttribute('data-cell-id')
            attachId.value = button.getAttribute('data-attach-id')
            attachName.value = button.getAttribute('data-attach-name')
            putOff.value = (button.getAttribute('data-attach-putOff') === 'true')
            boardId.value = button.getAttribute('data-board-id')
            //pdfUrl.value = "/WorkSpace/Content/Attach/"+attachId.value+"_"+attachName.value
            pdfUrl.value = attachFolder + attachId.value + "_" + attachName.value
            //getContent(cnttId.value)    data-attach-putOff
            attachs.value = []
            getAttachs(boardId.value, cnttId.value)
            myOffCanvas.focus()
            console.log(" show AttachView's OC")
         })
         let myCarousel = document.getElementById('carouselAttach')
         myCarousel.addEventListener('slide.bs.carousel', function (event) {
            attachName.value = attachs.value[event.to].name
            //pdfUrl.value = "/WorkSpace/Content/Attach/"+attachs.value[event.to].id+"_"+attachs.value[event.to].name
            pdfUrl.value = attachFolder + attachs.value[event.to].id + "_" + attachs.value[event.to].name
            console.log('item index from:'+event.from)
            console.log('item index   to:'+event.to)
         })         
         console.log("AttachView's OC")
      })
      /*
      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }
      */

      function extension(fileName) {
         let exten = fileName.lastIndexOf(".");
         if (exten == -1) {
            return ""; // empty extension
         }
         return fileName.substring(exten+1);
      }

      function getAttachs(boardId, contentId) {
         WspService.getAttachs(boardId, contentId, putOff.value)
         .then(response => {
            console.log(response.data)
            //attachs.value = response.data
            attachs.value = []
            for ( let att of response.data ) {
               if ( extension(att.name).toUpperCase() != 'JDM' ) {
                  attachs.value.push( att )
               }
            }
            console.log(attachs.value)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function isImage(fileName) {
         let imageFileExten = ".jpg.apng.avif.gif.jpeg.jfif.pjpeg.pjp.png.svg.webp.bmp.ico.cur.tif.tiff."
         if (imageFileExten.lastIndexOf(extension(fileName.toLowerCase())) > 0) {
            return true
         }
         return false
      }
      
      function focusOff() {
         console.log('out-focus-attach')
         store.dispatch("wspace/setOffCanvas", 6)
      }

      return {
         attachs,
         attachFolder,
         attachId,
         attachName,
         cnttId,
         content,
         extension,
         focusOff,
         isImage,
         pdfUrl,
      }
   }
}
</script>

<style scoped>
/*
@media (min-width: 768px) {
   .offcanvas-end {
   top: 25px;
   right: 100px;
   width: 600px;
   height: fit-content;
   }
}
@media (max-width: 767px) {
   .offcanvas-end {
   top: 25px;
   right: 10%;
   width: 80%;
   height: fit-content;
   }
}
*/
.btn-exit {
   color: white;
   font-size: 18px;
   text-decoration: none;
}
.clr-white {
   color: white;
}
.hgh-10 {
   height: 10%;
}
.alto {
   top: 10%;
   right: 20px;
}
.offcanvas-end {
   width: 100%;
}
.of-x {
   max-width: 100%;
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-save {
   opacity: .7;
   background-color: blue;
   color: white;
}
.btn-save:hover {
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.bg-l-gray {
   background-color: darkgray ;
/*   background-color:  #ecf0f1 ;*/
}
.btt-attach {
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.fs-11 {
   font-size: 11px;
}
</style>